require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-following-two-military-coups-how-can-the-world-bank.json") })
        }
      }, "path---en-us-update-following-two-military-coups-how-can-the-world-bank");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-following-two-military-coups-how-can-the-world-bank!./.cache/json/en-us-update-following-two-military-coups-how-can-the-world-bank.json
// module id = 663
// module chunks = 231608221292675